<div class="page-wrapper">
  <!-- Page Header -->
  <div class="page-header">
    <h2>Exclusions</h2>
    <p>
      To view an Exclusion, select a client and group from the dropdown boxes
    </p>
  </div>

  <!-- Form Section -->
  <app-benefit-form
    (onClientSelect)="onFieldsSelect($event)"
    (benefitList)="filterList($event)"
    (noDataForClient)="NoDataHandling($event)"
    (clearDataEvent)="clearData($event)"
  ></app-benefit-form>
  @if (!isNoData) {
    <div>
      @if (exclusions$ | async; as exclusions) {
        <!-- Details Information Section -->
        <div class="detail-information info-margin">
          <h2>Information</h2>
          <div class="mat-row">
            <div class="mat-12">
              <p class="bold-text pad-b-half">
                The following are therapeutic categories or medications that are
                not covered under your program. These medications may be available
                at a discount when you use your EmpiRx Health ID Card.
              </p>
            </div>
          </div>
        </div>
        <!-- Tabs Information Section -->
        <div class="tabs-information info-margin mat-custom-tab pad-t-0">
          <mat-tab-group animationDuration="0ms">
            <mat-tab label="Mail">
              <div class="pad-1">
                @if (
                  exclusionsRes &&
                  exclusionsRes.mail &&
                  exclusionsRes.mail.length > 0
                  ) {
                  <div
                    >
                    <div class="clear-both">
                      <ul class="item-list">
                        @for (mail of exclusionsRes.mail; track mail; let i = $index) {
                          <li
                            class="three-column"
                            >
                            {{ mail | titlecase }}
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
                @if (
                  exclusionsRes.mail == undefined && exclusionsRes.mail == null
                  ) {
                  <div
                    >
                    No Data
                  </div>
                }
              </div>
            </mat-tab>
            <mat-tab label="Retail">
              <div class="pad-1">
                @if (exclusionsRes.retail && exclusionsRes.retail.length > 0) {
                  <div
                    >
                    <div class="clear-both">
                      <ul class="item-list">
                        @for (retail of exclusionsRes.retail; track retail; let i = $index) {
                          <li
                            class="three-column"
                            >
                            {{ retail | titlecase }}
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
                @if (
                  exclusionsRes.retail == undefined &&
                  exclusionsRes.retail == null
                  ) {
                  <div
                    >
                    No Data
                  </div>
                }
              </div>
            </mat-tab>
            <mat-tab label="Specialty">
              <div class="pad-1">
                @if (
                  exclusionsRes &&
                  exclusionsRes.specialty &&
                  exclusionsRes.specialty.length > 0
                  ) {
                  <div
                    >
                    <div class="clear-both">
                      <ul class="item-list">
                        @for (
                          specialty of exclusionsRes.specialty; track
                          specialty; let i = $index) {
                          <li
                            class="three-column"
                            >
                            {{ specialty | titlecase }}
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
                @if (
                  exclusionsRes.specialty == undefined &&
                  exclusionsRes.specialty == null
                  ) {
                  <div
                    >
                    No Data
                  </div>
                }
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      }
    </div>
  }
  @if (isNoData) {
    <div>No data is available for selected client.</div>
  }

  @if (!(exclusions$ | async) && groupChosen) {
    <div>No Data Found.</div>
  }
</div>
